class Index {
    constructor() {
        /*
        * Hover method to lock or unlock fa icon
        */
        $('.sign-in-area').hover(function () {
            $(this).find("i").removeClass("fa-lock").addClass("fa-unlock-alt");
        }, function () {
            $(this).find("i").removeClass("fa-unlock-alt").addClass("fa-lock");
        });
    }
}
let index = new Index();

//# sourceMappingURL=index.js.map
